<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">门禁记录</h1>
			<div>
				<el-select class="select1" v-model="device_id" placeholder="请选择门禁" @change="getUsers()">
		          <el-option v-for="(dev,index) in devList" :label="dev.cname" :key="index" :value="dev.id"></el-option>
		        </el-select>
				<el-select class="select1" value-key="id" v-model="enrollid" placeholder="请选择用户">
		          <el-option key="-1" value="" label="所有用户"></el-option>
		          <el-option v-for="(user,index) in userList" :label="user.name" :key="index" :value="user.enrollid"></el-option>
		        </el-select>
				<el-date-picker
			      v-model="startdate"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="开始日期">
			    </el-date-picker>
			    <el-date-picker
			      v-model="enddate"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="结束日期">
			    </el-date-picker>
			    <el-button @click="getDetail(-1)"> 查 看 </el-button>
			</div>
			<br>

			<el-table
			stripe
			border
			:data="tableData"
			style="width: 100%">
				<el-table-column
				type="index"
				width="80">
				</el-table-column>
				<el-table-column
					prop="name"
					label="姓名">
				</el-table-column>
				<el-table-column
					prop="mode"					
					label="访问方式"
					:formatter="visitWay">
				</el-table-column>
				<el-table-column
					prop="time"
					label="时间"
					:formatter="dateFormatThree">
				</el-table-column>
				<!-- <el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small"
							@click="">远程开门
					</el-button>
					
				</template>
				</el-table-column> -->
			</el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pageSize"
				  :current-page.sync="nowPage"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
		device_id: 1,
		enrollid: "",
		startdate: new Date(),
		enddate: new Date(),
		tableData:[],
		nowPage:1,
		pageSize:12,
		totalNum:0,
		devList: [],
		userList: [],
		
    }
  },
  mounted(){
    this.$nextTick(function(){		
		//格式化结束时间
		let date = this.enddate;
		date = [
			[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
		].join(' ').replace(/(?=\b\d\b)/g, '0');
		this.enddate = date;		
		//格式化当前时间90天前
		var date2 = new Date();
		var date21 = date2.getTime() - 3600 * 1000 * 24 * 90;
		date2.setTime(date21);
		date2 = [
			[date2.getFullYear(), date2.getMonth() + 1, date2.getDate()].join('-')
		].join(' ').replace(/(?=\b\d\b)/g, '0');
		this.startdate = date2;

		this.getDoors();
		this.getUsers();
    	this.getDetail();
  	})
  },

  methods: {
	getDetail(num){
		if(num==-1){
			this.nowPage = 1;
		}
		// console.log(this.nowPage);
		let valiCodeParams={
			uid:this.getCookie('uid'),
			device_id: this.device_id || "",
			enrollid: this.enrollid || "",
			startdate: Date.parse(this.startdate)/1000,
			enddate: Date.parse(this.enddate)/1000,
			page: this.nowPage.toString(),
			pagesize: 12,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardLogList",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.tableData = res.data.data.datalist || [];
				this.totalNum = res.data.data.totalNumber || 0;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	handleCurrentChange(val) {
		this.nowPage = val;
		this.getDetail();
	},
	// 获取用户列表
	getUsers(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			device_id: this.device_id,
			page: 1,
			pagesize: 9999,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardUserList",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.userList = res.data.data.datalist || [];
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	// 获取门禁设备列表
	getDoors(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/FaceManage/List",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.devList = res.data.data;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/door.vue